import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Clipboard } from '@angular/cdk/clipboard';
import { toSignal } from '@angular/core/rxjs-interop';
import { MSAL_INSTANCE, MsalService } from '@azure/msal-angular';
import { IPublicClientApplication } from '@azure/msal-browser';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { map } from 'rxjs';
import { ButtonDirective } from 'primeng/button';
import { Popover } from 'primeng/popover';
import { Tag } from 'primeng/tag';

@Component({
  selector: 'bd-menu-dev-info-button',
  template: `
    @if (visible()) {
      <p-tag class="cursor-pointer" (click)="popover.toggle($event)"
        >Testsystem</p-tag
      >

      <p-popover #popover>
        <div class="flex flex-col gap-3 max-w-xs">
          <div class="flex flex-col gap-1">
            <span
              class="text-[10px] font-semibold uppercase tracking-wider text-(--p-text-muted-color)"
              >Testsystem</span
            >
            <span class="text-sm text-(--p-text-color)"
              >Werte können abweichen oder variieren.</span
            >
          </div>
          <button pButton type="button" class="w-full" (click)="copyJwtToken()">
            <i class="pi pi-sparkles mr-2"></i>
            <span>JWT Token kopieren</span>
          </button>
        </div>
      </p-popover>
    }
  `,
  imports: [ButtonDirective, Popover, Tag],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdMenuDevInfoButtonComponent {
  private readonly _environmentService = inject(BdAppEnvironmentService);
  private readonly _msalInstance =
    inject<IPublicClientApplication>(MSAL_INSTANCE);
  private readonly _msalService = inject(MsalService);
  private readonly _clipboard = inject(Clipboard);
  private readonly _breakpointObserver = inject(BreakpointObserver);

  private readonly _isLargeScreen = toSignal(
    this._breakpointObserver
      .observe([Breakpoints.Large, Breakpoints.XLarge])
      .pipe(map((result) => result.matches)),
    { initialValue: false },
  );

  public readonly visible = computed(
    () =>
      this._environmentService.load('BD_STAGING_BANNER', true) === 'true' &&
      this._isLargeScreen(),
  );

  public copyJwtToken(): void {
    this._msalService.instance
      .acquireTokenSilent({
        account: this._msalService.instance.getActiveAccount(),
        authority: this._msalInstance.getConfiguration().auth.authority,
        scopes: [this._msalInstance.getConfiguration().auth.clientId],
      })
      .then((it) => this._clipboard.copy(`Bearer ${it.accessToken}`));
  }
}
